"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DebugPill = ({ style, ...props }) => (react_1.default.createElement("div", { style: {
        backgroundColor: 'green',
        borderRadius: '1000px',
        padding: '4px 12px',
        margin: '8px',
        fontSize: '12px',
        color: 'white',
        boxShadow: '0 0 4px #0003',
        display: 'inline-block',
        zIndex: '100',
        ...(style || {})
    }, ...props }));
exports.default = DebugPill;
//# sourceMappingURL=debug-pill.js.map